import ServiceLocator from "../../global/service-locator";
import Navigator from "../../global/navigator";
import Extensions from "../../extensions";
import Header from "./header";
import Footer from "./footer";
import WidgetMailingPopup from "./widget-mailing-popup";
import LangSwitcher from "../../global/lang-switcher";
import SpecialEventPopup from "../../components/special-event/special-event-popup";
import SpecialEventQuiz from "../../components/special-event/special-event-quiz";
import Consent from "../../components/consent";

export default class CoreModule {
	constructor() {
		this.sl = ServiceLocator.instance;
		this.navigator = new Navigator();
		this.extensions = new Extensions();
		this.header = new Header();
		this.footer = new Footer();

		this.initMailingPopup();
		this.initLangSwitcher();
		this.initSpecialEvent();
		this.initConsent();
	}

	initMailingPopup() {
		const mailingPopup = new WidgetMailingPopup();
	}

	initLangSwitcher() {
		const langSwitcher = new LangSwitcher();
	}

	initSpecialEvent() {
		if (craft.page.specialEventConfig == null || !craft.page.specialEventConfig.status) return;

		new SpecialEventPopup();
		new SpecialEventQuiz();
	}

	initConsent() {
		new Consent();
	}
}